<template>
  <div>
    <iframe class="static-content-wrapper" v-if="method === 'iframe'" id="iframe" :src="url" scrolling="no" frameborder="0" :style="{'height' : iframeHeight}" @load="iframeLoaded"></iframe>
    <div class="static-content-wrapper" v-if="method === 'html' && html" v-html="html"></div>
  </div>
</template>
<script>
  import config from '@/config'
  import http from 'axios'
  import Screen from '@/components/mixins/Screen'
  import Branding from '@/components/mixins/Branding'
  import Url from '@/components/mixins/Url'
  import store from '@/store'

  export default {
    name: 'StaticContent',

    props: {
      fullPath: {
        type: Boolean,
        default: false
      },
      staticcontentpath: {
        type: String,
        default: '/static/static-content/'
      },
      method: {
        type: String,
        default: 'html'
      }
    },

    mixins: [
      Screen,
      Branding,
      Url
    ],

    data: () => ({
      iframeHeight: '400px',
      html: null
    }),

    computed: {
      placeholders () {
        return {
          '{mediaServer}': this.mediaServerHostname(),
          '{brand}': config.app.BRAND
        }
      },
      infoPageName () {
        return this.$route.params.infopagename
      },
      staticContentPath () {
        return this.mediaServerHostname() + this.staticcontentpath
      },
      url () {
        var result = ''

        if (this.fullPath) {
          result = this.staticContentPath
        } else {
          result = this.staticContentPath + this.infoPageName + '.html'
        }
        return result
      },
      MobilelocalServer () {
        return window.ctsautoconf.MOBILE_LS || false
      }
    },
    methods: {
      getHtml () {
        if (this.method === 'html') {
          window.scroll(0, 0)
          http.get(this.url).then((response) => {
            if (response && response.data) {
              this.html = response.data
              this.replacePlaceholders()
              this.setNetworkLogOutput({'request': this.url, 'response': response})
              this.scrollToElement()
            }
          }).catch((error) => {
            this.setNetworkLogOutput({'request': this.url, 'response': error})
          })
        }
      },
      replacePlaceholders () {
        if (this.placeholders && this.html) {
          for (var placeholder in this.placeholders) {
            if (this.placeholders.hasOwnProperty(placeholder) && this.placeholders[placeholder]) {
              let search = new RegExp(placeholder, 'g')
              this.html = this.html.replace(search, this.placeholders[placeholder])
            }
          }
        }
      },
      iframeLoaded () {
        setTimeout(() => {
          this.iframeHeight = (document.getElementById('iframe').contentWindow.document.body.scrollHeight + 40) + 'px'
        }, 1)
      },
      setNetworkLogOutput (data) {
        if (window.ctsautoconf.MOBILE_LS && config.app.autoconf.MOBILE_DEBUGGER_DIALOG && config.app.autoconf.MOBILE_DEBUGGER_DIALOG.ENABLED) {
          let date = Date.now()
          store.commit('setNetworkLogOutput', {'date': date, 'type': 'media', 'request': data.request, 'dynamicId': this.revisedRandId(), 'response': data.response})
        }
      },
      revisedRandId () {
        let randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26))
        return randLetter + Date.now()
      },
      scrollToElement () {
        if (this.$route && this.$route.hash && !this.$route.path.includes('/info/faq')) {
          let _self = this
          setTimeout(function () {
            const offset = _self.MobilelocalServer ? 100 : 150
            window.scrollTo({
              behavior: 'smooth',
              top:
                document.querySelector(_self.$route.hash).getBoundingClientRect().top -
                document.body.getBoundingClientRect().top -
                offset
            })
          }, 1000)
        }
      }
    },
    mounted () {
      this.getHtml()
    },
    created () {},

    watch: {
      url () {
        this.getHtml()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" >
@import "~@/css/config"

iframe
  width 100%
  height 100%
  // min-height 400px
.static-content
  .ca
    padding 5px 0
    .pd-icon
      width 30px
      display inline-flex
      align-items center
      justify-content center
  .ca_email .pd-icon
    font-size 15px

.static-content-wrapper
  .column
    float: left
    width: 50%
    padding-top: 20px
    padding-bottom: 20px
    padding-left: 20px
    padding-right: 20px

  .row:after
    content: ""
    display: table
    clear: both

  @media screen and (max-width: 600px)
    .column
      width: 100%


  .bordered
    width: 300px
    height: 300px
    padding: 20px
    border: 3px solid #273c4b
    border-radius: 8px

  .table
    border-spacing:10px


  input[type='checkbox']
    display: none

  .lbl-toggle
    display: block

    font-weight: bold
    font-family: Avenir Next
    font-size: 1.2rem
    text-transform: uppercase
    text-align: center

    padding: 1rem
    margin-top: 1px

    color: #FFFFFF
    background: #273c4b

    cursor: pointer

    border-radius: 7px
    transition: all 0.25s ease-out


  .lbl-toggle:hover
    color: #ffbf4b

  .lbl-toggle::before
    content: ' '
    display: inline-block

    border-top: 5px solid transparent
    border-bottom: 5px solid transparent
    border-left: 5px solid currentColor

    vertical-align: middle
    margin-right: .7rem
    transform: translateY(-2px)

    transition: transform .2s ease-out

  .collapsible-content .content-inner
    background: rgba(230, 230, 231, 1)
    border-bottom: 1px solid rgba(12, 18, 29, 1)

    border-bottom-left-radius: 7px
    border-bottom-right-radius: 7px
    padding: .5rem 1rem

  .collapsible-content
    max-height: 0px
    overflow: hidden

    transition: max-height .25s ease-in-out

  .toggle:checked + .lbl-toggle + .collapsible-content
    max-height: 500vh

  .toggle:checked + .lbl-toggle::before
    transform: rotate(90deg) translateX(-3px)


  .toggle:checked + .lbl-toggle
    border-bottom-right-radius: 0
    border-bottom-left-radius: 0

  table, th, td
    border:1px solid black
</style>



// WEBPACK FOOTER //
// src/components/common/StaticContent.vue